import {fmt} from '@packages/utilities/prompt-formatter';
import type {ToolRegistryGroup} from '../../types/tool-registry-types';
import {searchKnowledgeBaseManifest} from '../../tool-manifests/search-knowledge-base';

const DESCRIPTION = fmt`
  This tool group provides access to a knowledge base of Webflow guides and video 
  transcripts. This is an excellent tool group to select if the user is asking a 
  question about Webflow, or as a backup if none of the other tool groups are 
  applicable.
`;

const SYSTEM_PROMPT = fmt`
  You have access to a knowledge base of Webflow guides and video transcripts. 
  Call \`${searchKnowledgeBaseManifest.id}\` whenever you need to answer from Webflow documentation.

  If a search returns follow up questions, you must format the follow up questions
  in the following way:

  <wf-response id="button-group">
    <buttons>
      <button id="button-1">Follow up question 1</button>
      <button id="button-2">Follow up question 2</button>
      ...
    </buttons>
  </wf-response>
`;

export const knowledgeBaseToolGroup: ToolRegistryGroup = {
  name: 'Knowledge Base',
  description: DESCRIPTION,
  systemPrompt: SYSTEM_PROMPT,
  tools: [searchKnowledgeBaseManifest],
};
